import { chatterClientsApi } from "store/services/clients/chatter";
import { homeEducationApi } from "store/services/clients/homeEducation";
import { privateClientApi } from "store/services/clients/private";
import { schoolClientsApi } from "store/services/clients/school.client";

/**
 * Custom wrapper to invalidate RTK Query api tag cache
 * @param {*} queryFulfilled 
 * @param {*} dispatch 
 * @param {*} api 
 * @param {*} tags 
 */
export const invalidateAPITags = async (queryFulfilled, dispatch, api, tags) => {
  try {
    await queryFulfilled;
    dispatch(api.util.invalidateTags(tags)); // Invalidate the specified tags
  } catch (error) {
    console.error("Failed to invalidate tags:", error);
  }
};

export const invalidateAllClientsListing = async (queryFulfilled, dispatch) => {
  try {
    await queryFulfilled;
    dispatch(schoolClientsApi.util.invalidateTags(["SchoolClients"]));
    dispatch(privateClientApi.util.invalidateTags(["PrivateClientList"]));
    dispatch(homeEducationApi.util.invalidateTags(["HomeEducationList"]));
    dispatch(chatterClientsApi.util.invalidateTags(["ChatterClients"]));
  } catch (error) {
    console.error("Failed to invalidate client listing tags:", error);
  }
}